<template>
    <HLCardLayout :scale="(isTabletOrPhone)?0.9:(isXlDevice)?0.4:0.7" :minHeight="(isSmAndUpDevice)?'600':null" :horizontalMargin="isLgAndUpDevice" disablePadding>
        <template #header-action>
            <v-btn
                v-if="headerAction"
                class="mt-1 mb-sm-2 ml-n3"
                elevation="0"
                fab
                dark
                small
                @click.stop="onHeaderAction"
                color="rgba(0,0,0,0.8)"
            >
                <v-icon dark opacity="0.5">
                    {{ headerAction.icon }}
                </v-icon>
            </v-btn>
        </template>
        <template #content>
            <HLEventList @next="onSelectedEvent"/>
        </template>
    </HLCardLayout>
</template>

<script>
import {layoutMixin} from "../../utils/layout-mixin";
import {settingsMixin} from "../../utils/settings-mixin";
import {eventMixin} from "../../utils/event-mixin";
import {qrLoginMixin} from "../../utils/qrlogin-mixin";
import {onboardingMixin} from "../../utils/onboarding-mixin";
import HLCardLayout from "../../components/dashboard/HLCardLayout.vue";
import HLEventList from "../../components/dashboard/HLEventList.vue";
export default {
    mixins: [layoutMixin,settingsMixin,eventMixin,qrLoginMixin,onboardingMixin],
    components:{
        HLEventList,
        HLCardLayout
    },
    data(){
        return {

        }
    },
    computed: {
        cameFromEvent() {
            return !!this.from && this.from.indexOf('/event/') === 0 && null != this.selectedEventId;
        },
        // back to the game, back to the selection card, or logout; never a link to /login while logged in
        headerAction() {
            if (this.cameFromEvent) {
                return { icon: 'mdi-arrow-left', action: 'event' };
            }
            if (this.cardEffective && this.cardHasContent) {
                return { icon: 'mdi-arrow-left', action: 'card' };
            }
            if (!this.disableLogout) {
                return { icon: 'mdi-logout', action: 'logout' };
            }
            return null;
        }
    },
    methods: {
        onSelectedEvent(id){
            this.setThemeColors(id)
            this.goToEvent(id);
        },
        onHeaderAction() {
            switch (this.headerAction && this.headerAction.action) {
                case 'event':
                    this.goToEvent(this.selectedEventId);
                    break;
                case 'card':
                    this.goToEventSelect();
                    break;
                case 'logout':
                    this.navigateTo({ path: '/logout' });
                    break;
                default:
                    break;
            }
        }
    },
}
</script>

<style scoped>

.container{
    max-width: 600px;
}

</style>
